import { Box } from "@mui/material";

const FollowUpActionRow = ({ children, containerRef, sx = {} }) => (
  <Box
    ref={containerRef}
    data-follow-up-action-row="true"
    role="group"
    aria-label="Suggested next actions"
    sx={{
      width: "100%",
      minWidth: 0,
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "stretch",
      justifyContent: "center",
      gap: "8px",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default FollowUpActionRow;
